// 'use client'

// import React from "react"
// import ErrorPage from "../individual-components/error-page"

// class ErrorBoundary extends React.Component {
//     constructor(props) {
//         super(props)

//         // Define a state variable to track whether is an error or not
//         this.state = { hasError: false }
//     }
//     static getDerivedStateFromError(error) {
//         // Update state so the next render will show the fallback UI

//         return { hasError: true }
//     }
//     componentDidCatch(error, errorInfo) {
//         // You can use your own error logging service here
//         console.log({ error, errorInfo })
//     }
//     render() {
//         // Check if the error is thrown
//         if (this.state.hasError) {
//             // You can render any custom fallback UI
//             return (
//                 <ErrorPage header={'Something went wrong'}>
//                     <img src='no-data.svg' className='w-[500px] max-w-full' />
//                 </ErrorPage>
//             )
//         }

//         // Return children components in case of no error

//         return this.props.children
//     }
// }

// export default ErrorBoundary

'use client'

import React from "react"
import ErrorPage from "../individual-components/error-page"
import { accessToken, rootUrl } from "@/api-config/constant"

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)

        // Define a state variable to track whether is an error or not
        this.state = { hasError: false, error: null, errorInfo: null }
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return { hasError: true }
    }

    componentDidCatch(error, errorInfo) {
        // Update state with error details
        this.setState({ error, errorInfo })

        let location;
        // Prepare error details for API call
        const errorDetails = {
            error: String(error),
            pagePath: window.location.href,
            stackTrace: String(errorInfo?.componentStack || ''),
            region: location?.regionName || 'Unknown',
            city: location?.city || 'Unknown',
            country: location?.country || 'Unknown',
            ipAddr: 'ipData', // Replace with actual IP fetching logic if needed
        }

        // Make an API call with error details
        fetch(`${rootUrl}/addErr`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Token': accessToken },
            body: JSON.stringify(errorDetails),
        }).catch(console.error)
    }

    render() {
        // Check if the error is thrown
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <ErrorPage header={'Something went wrong'}>
                    <img src='/images/no-data.svg' className='w-[500px] max-w-full' />
                    <div>
                        <p className="text-2xl">{String(this.state.error)}</p>
                    </div>
                </ErrorPage>
            )
        }

        // Return children components in case of no error
        return this.props.children
    }
}

export default ErrorBoundary
